import React from 'react';

import AuthUserContext from './AuthUserContext';
import { PasswordForgetForm } from './PasswordForget';
import PasswordChangeForm from './PasswordChange';
import withAuthorization from './withAuthorization';

const pageStyle = {
  //backgroundImage: 'url(' + imgUrl + ')',
  padding: "80px",
  margin: "20px",
  textAlign: "justify",
  WebkitTransition: 'all', // note the capital 'W' here
  msTransition: 'all' // 'ms' is the only lowercase vendor prefix
};


const AccountPage = () =>
  <AuthUserContext.Consumer>
    {authUser =>
      <div style={pageStyle}>
      <h2>Forgotten Your Password?</h2>
      <p> Enter your email address  and press 'reset my password'</p>
      <p> This will send you an email that will allow you to enter a new password </p>
        <h3>Account: {authUser.email}</h3>
        <PasswordForgetForm />

        <h2>Want to Change your Password?</h2>
        <p> Enter your new password and then repeat</p>
        <p> Then click the reset button </p>
        <PasswordChangeForm />
        <p> Any problems that you cannot resolve please contact support@assentian.com</p>
      </div>
    }
  </AuthUserContext.Consumer>

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(AccountPage);



// WEBPACK FOOTER //
// ./src/components/Account.js